import { useState } from 'react';
import { TurnRating } from '../components/TurnFeedback';

// Turn ratings (thumbs up/down), keyed by turn_id, not message.id — lifted
// out of TurnFeedback so a rating survives history pagination/scrolling
// within the current page session. The backend doesn't return prior ratings
// on history fetch and doesn't need to (resubmitting just upserts), so this
// is intentionally in-memory only: reset via resetTurnRatings() whenever the
// user leaves the current chat (new chat, or switching to a different
// history session).
export const useTurnFeedback = () => {
  const [turnRatings, setTurnRatings] = useState<Record<string, TurnRating>>({});

  const handleTurnRated = (turnId: string, rating: TurnRating) => {
    setTurnRatings((prev) => ({ ...prev, [turnId]: rating }));
  };

  const resetTurnRatings = () => {
    setTurnRatings({});
  };

  return { turnRatings, handleTurnRated, resetTurnRatings };
};
